import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';

export type GetUserSessionsResponse = {
  userId: string;
  sessionId: string;

  isCurrentSession: boolean;

  session: string;
  userAgent: string;

  createdAt: string;
}[];

export const useGetUserSessionsQuery = () => {
  return useQuery({
    queryKey: ['auth', 'sessions'],
    queryFn: async () => {
      const { data } = await client.get<{ body: GetUserSessionsResponse }>(`/auth/sessions`);

      return data.body;
    },
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
};
